import { Box, Grid, InputAdornment, Typography, styled } from "@mui/material";
import { TRADE_AMOUNT_TYPE, TRADE_SIDE } from "../constants";

import NumberFormats from "components/NumberFormats";
import PriceInput from "components/PriceInput";
import { useFormContext } from "react-hook-form";

function TradeInput({
  srcDecimalCount,
  destDecimalCount,
  sourceCoin,
  coinMarketDetails,
  amountPlaceholderCoin,
  minimumTradeAmount,
  maximumTradeAmount,
  destinationCoin,
  tradeAmountMax,
}) {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const isPrice = watch("isPrice");
  const amountTypeId = watch("amountTypeId");
  const sideId = watch("sideId");

  const maxDecimalCount =
    amountTypeId === TRADE_AMOUNT_TYPE.amount.id
      ? srcDecimalCount
      : destDecimalCount;

  return (
    <Grid container spacing={1}>
      {sourceCoin?.extraUnitComment && (
        <Grid item xs={12}>
          <BadgeShape>
            <Typography
              variant="subtitle1"
              fontWeight={500}
              color="text.main"
              display="flex"
              justifyContent="center"
            >
              {sourceCoin?.extraUnitComment}
            </Typography>
          </BadgeShape>
        </Grid>
      )}

      {isPrice && (
        <Grid item xs={12}>
          <PriceInput
            value={watch("price")}
            onChange={(e) => setValue("price", e)}
            error={!!errors?.price}
            helperText={errors?.price?.message}
            maxDecimal={destDecimalCount}
            placeholder={`Price`}
            coinName={coinMarketDetails?.coinDestinationName}
            showPrefix={false}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography mr={1} variant="h5" color="text.secondary">
                    {coinMarketDetails?.coinDestinationName}
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <PriceInput
          value={watch("amount")}
          onChange={(e) => setValue("amount", e)}
          error={!!errors?.amount}
          maxDecimal={maxDecimalCount}
          helperText={errors?.amount?.message}
          placeholder={`Amount`}
          coinName={amountPlaceholderCoin}
          min={minimumTradeAmount}
          max={maximumTradeAmount}
          showPrefix={false}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Typography mr={1} variant="h5" color="text.secondary">
                  {amountPlaceholderCoin}
                </Typography>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6" component="p" color="text.secondary">
          Avbl:{" "}
          <Typography variant="h6" component="span" color="text.main">
            <NumberFormats value={tradeAmountMax?.availableBalance} />{" "}
          </Typography>
          {sideId === TRADE_SIDE.Sell.id
            ? sourceCoin?.name
            : destinationCoin?.name}
        </Typography>
      </Grid>
    </Grid>
  );
}

export const BadgeShape = styled(Box)(({ theme }) => ({
  width: "100%",
  background: theme.palette.text.alternate,
  borderRadius: "8px",
  padding: theme.spacing(0.5),
}));

export default TradeInput;
